import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import RxOrderFormPage from './RxFormPage';
import { push } from 'react-router-redux';
import { getRxOrderData, getMessage, onFilesChange, onFilesError, sendMessageAttachment, getFiles, messaging, getFeedbackData } from 'src/actions/rxformAction';
import { renderSTLImage } from 'src/actions/stlViewerAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { rework } from 'src/actions/liveOrderAction';
import { orderno, orderDisabled } from 'src/actions/supportAction';
import { GetFileData } from 'src/reducers/rxForm';
import { openVideoPlayerURL, openVideoPlayerURLArray } from 'src/actions/landingPageAction';
import { downloadMessageAttachment, downloadOrderFile } from 'src/actions/filedownloadAction';
import { approvalRequired } from 'src/actions/completeOrderAction';
import { getSupportTypes } from 'src/actions/supportRequestAction';

export const mapStateToProps = (state: AppState) => {
  return {
    userDetails: state.user.userDetails,

    orderno: state.completeOrder.viewCompleteOrder[0].orderno,
    filename: state.completeOrder.viewCompleteOrder[0].fname,
    filepath: state.completeOrder.viewCompleteOrder[0].fpath,
    feedback: state.completeOrder.viewCompleteOrder[0].feedback,
    createddate: state.completeOrder.viewCompleteOrder[0].orderdate,
    duedate: state.completeOrder.viewCompleteOrder[0].dueby,
    lab: state.completeOrder.viewCompleteOrder[0].labname,
    customerstatus: state.completeOrder.viewCompleteOrder[0].customerstatus,
    vfiles: state.completeOrder.viewCompleteOrder[0].vfiles,
    status: state.completeOrder.viewCompleteOrder[0].status,
    caseNotes: state.completeOrder.viewCompleteOrder[0].casenotes,
    tool_preferred: state.completeOrder.viewCompleteOrder[0].tool_preferred,
    completedon: state.completeOrder.viewCompleteOrder[0].completedon,
    destination: state.completeOrder.viewCompleteOrder[0].destination,
    designername: state.completeOrder.viewCompleteOrder[0].designername,
    fqcname: state.completeOrder.viewCompleteOrder[0].fqcname,
    mdesignername: state.completeOrder.viewCompleteOrder[0].mdesignername,
    designapproval: state.completeOrder.viewCompleteOrder[0].approval_reqd,
    modelonly: state.completeOrder.viewCompleteOrder[0].modelonly,
    bravo: state.completeOrder.viewCompleteOrder[0].bravopremium,
    fdownload: state.completeOrder.viewCompleteOrder[0].fdownload,
    qc_required: state.completeOrder.viewCompleteOrder[0].qc_required,
    downloadedon: state.completeOrder.viewCompleteOrder[0].downloadedon,

    rxDetails: state.UserRxFormData.userRxdata,

    designtype: state.UserRxFormData.designtype,
    notations: state.UserRxFormData.notations,
    product: state.UserRxFormData.product,
    // productname: state.UserRxFormData.productname,
    model: state.UserRxFormData.model,
    getMessage: state.UserRxFormData.getUserMessage,
    customer: state.user.userDetails.userName,
    messages: state.UserRxFormData.message,
    getFilesData: state.UserRxFormData.getFileData,

    messageFiles: state.UserRxFormData.messageFiles,
    orderDataTat: state.fileUpload.orderDataTat,
    orderDataManufacturer: state.fileUpload.orderDataManufacturer,
    redesignReasons: state.completeOrder.redesignReasons,

    verticalViewScreen: state.landingPage.verticalViewScreen,
    refno: state.completeOrder.viewCompleteOrder[0].refno,
    drpref: state.completeOrder.viewCompleteOrder[0].drpref,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onComponentDidMount: () => {
      dispatch(onFilesChange([]));
      // dispatch(getRedesignReasons);
    },
    onComponentWillMount: () => {
      dispatch(doCheckAuthentication);
      // dispatch(clearDataOnOpen);
    },
    onFeedback: () => {
      dispatch(push('/app/feedback'));
    },
    onViewFeedback: () => {
      dispatch(push('/app/viewfeedback'));
      dispatch(getFeedbackData);
    },
    getRxDetails: () => {
      dispatch(getRxOrderData);
    },
    getFiles: () => {
      dispatch(getFiles);
    },
    getMessages: () => {
      dispatch(getMessage);
    },
    redesignRequest: (columns: Object) => {
      dispatch(rework(columns, 'completed'));
    },
    supportPage: (order: string) => {
      dispatch(orderno(order));
      dispatch(orderDisabled(true));
      dispatch(getSupportTypes);
      dispatch(push('/app/support'));
    },
    downloadFile: (filepath: string, filename: string, status: string, ociStatus: string, ordernumber: string) => {
      dispatch(downloadOrderFile(filepath, filename, status, ociStatus, ordernumber));
    },
    messaging: (messages: string) => {
      dispatch(messaging(messages));
    },
    onSubmit: () => {
      dispatch(sendMessageAttachment);
    },
    onFilesChange: function (messageFiles: Array<File>) {
      dispatch(onFilesChange(messageFiles));
    },
    onFilesError: function (error: Error, images: Array<File>) {
      dispatch(onFilesError(error, images));
    },
    getApiMessage: () => {
      dispatch(getMessage);
    },
    msgAtt: (msgAttachment: string, ociStatus: string) => {
      dispatch(downloadMessageAttachment(msgAttachment, ociStatus));
    },
    goStlViewer: (data: GetFileData[]) => {
      dispatch(renderSTLImage(data));
    },
    openVideoPlayerURL: (fullPath: GetFileData[]) => {
      dispatch(openVideoPlayerURL(fullPath));
    },
    openVideoPlayerURLArray: (fullPath: string[], fpath: string) => {
      dispatch(openVideoPlayerURLArray(fullPath, fpath));
    },
    approvalRequired: (array: Array<object>) => {
      dispatch(approvalRequired(array));
    },
    submitRework: (column: Object) => {
      dispatch(rework(column, 'mhold'));
    },
  };
};

const RxOrderFormPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RxOrderFormPage);

export default RxOrderFormPageContainer;



// WEBPACK FOOTER //
// ./src/components/rxForm/RxFormPageContainer.tsx